import type { Container } from "inversify"
import type { ILanguageService, LanguageString } from "services/languageService"
import { TYPES } from "services/types"
import { IReactionDisposer, reaction } from "mobx"
import type { i18n } from "i18next"

export class I18nProviderViewModel {
  private languageService: ILanguageService
  private disposer: IReactionDisposer
  private i18nInstance: i18n

  constructor(container: Container, i18nInstance: i18n) {
    this.languageService = container.get<ILanguageService>(TYPES.ILanguageService)
    this.i18nInstance = i18nInstance
    const langLocalStorage = localStorage.getItem("language")
    const defaultLanguage =
      langLocalStorage !== "th" && langLocalStorage !== "en"
        ? this.languageService.language
        : langLocalStorage
    this.changeLanguage.bind(this)
    this.disposer = reaction(
      () => this.languageService.language,
      (language, _) => {
        this.changeLanguage(language)
      }
    )
    this.languageService.setLanguage(defaultLanguage as LanguageString)
    this.saveLocalStorage(defaultLanguage as LanguageString)
  }

  changeLanguage(language: LanguageString) {
    this.i18nInstance.changeLanguage(language)
    this.saveLocalStorage(language)
  }

  saveLocalStorage(language: LanguageString) {
    localStorage.setItem("language", language)
  }

  dispose() {
    this.disposer()
  }
}
